<div class="py-40 px-10 text-center text-xl text-bold">
  {{ statusMessage }}
</div>
